import { api } from "@/api";
import { virtualStreamPath } from "./virtualSportType";

// VBL standings row. Win/loss only (no draws); points = 2 per win.
export interface VirtualBasketballStandingRow {
  pos: number;
  team: string;
  teamUid: number; // VBL team uid (= logo teamid); 0 if absent
  played: number;
  win: number;
  loss: number;
  pointsFor: number;
  pointsAgainst: number;
  points: number;
  /** Position before the playing / last ended matchday; null at matchday 1.
   *  Optional so an older MD response still parses. */
  prevPos?: number | null;
}

// League standings (Puan Durumu) for the VBL league — a live table (includes the
// playing matchday's running scores), like Sportradar's livetable.
export const getVirtualBasketballStandings = async (
  leagueId: number
): Promise<VirtualBasketballStandingRow[]> => {
  const res = await api.client.get(
    virtualStreamPath("virtual-basketball", "standings"),
    { params: { leagueId } }
  );
  return res.data?.rows ?? [];
};
